import { left } from '@popperjs/core';
import { AgGridCustomDropdownComponent } from 'src/app/shared/common-components/ag-grid/ag-grid-custom-dropdown/ag-grid-custom-dropdown.component';
import { AgColDefsI, AgGridI } from 'src/app/shared/common-components/ag-grid/ag-grid.model';
import { CustomHeaderComponent } from 'src/app/shared/common-components/ag-grid/custom-header/custom-header.component';
import { DateCellRendererComponent } from 'src/app/shared/common-components/ag-grid/date-cell-renderer/date-cell-renderer.component';
import { EditDeleteIconComponent } from 'src/app/shared/common-components/ag-grid/edit-delete-icon/edit-delete-icon.component';
import { NumericCellRendererComponent } from 'src/app/shared/common-components/ag-grid/numeric-cell-renderer/numeric-cell-renderer.component';
import { TextRendererTwoSpanComponent } from 'src/app/shared/common-components/ag-grid/text-display-renderer/text-renderer-two-span.component';
import { TextRendererComponent } from 'src/app/shared/common-components/ag-grid/text-renderer/text-renderer.component';
import { StorageName, ContactColWidth } from 'src/app/shared/enum/common-enum';
import { StorageService } from 'src/app/shared/services/storage.service';
import { API_URL_GET_ALL_INVESTMENT_FUND_INSTALL_ENTRY } from 'src/app/shared/url-helper/url-helper';


const Party: AgColDefsI = {
  headerName: "Party",
  field   : 'accountLedgerName',
  cellClass: "text-primary custom-column-group-cell px-2 py-1",
  headerClass: "px-0 d-flex custom-column-group-cell",
  flex: 1,
  resizable: true,
  minWidth: 128,
  maxWidth:ContactColWidth.MaxWidth,
  sortable: false,
  editable: false,
  lockPosition: left,
  cellRenderer: TextRendererTwoSpanComponent,
  cellRendererParams: { isCursor: true, isPinkText: true, invoiceNumber: true },
  headerComponentParams: {
    filterValueColumnName: "accountLedgerName mobile",
    filterIdColumnName: "accountLedgerName",
    isInputFilter: true,
    
  },
}
const SchemeName: AgColDefsI = {
  headerName: "Scheme Name",
  field: 'schemeName',
  headerClass: "px-1 custom-column-group-cell border-0 f-14 text-gray-color font-semibold ag_header_end",
  flex: 1,
  sortable: false,
  editable: false,
  resizable: true,
  minWidth: 143,
  maxWidth:ContactColWidth.MaxWidth,
  cellRenderer: TextRendererTwoSpanComponent,
  cellRendererParams: { displayAmount:true, },
  headerComponentParams: {
    filterValueColumnName: "schemeName",
    filterIdColumnName: "schemeName",
    isInputFilter: true,
  },
  cellClass: 'px-0  custom-column-group-cell',
};
const InvoiceNumber: AgColDefsI = {
  headerName: "Invoice No.",
  field: 'invoiceNo',
  headerClass: "px-1 custom-column-group-cell border-0 f-14 text-gray-color font-semibold ag_header_end",
  flex: 1,
  sortable: true,
  editable: false,
  resizable: true,
  minWidth: 80,
  cellRenderer: TextRendererComponent,
  cellRendererParams: { isCursor: true },
  cellClass: 'text-primary custom-column-group-cell text-center px-2 py-1',
};

export const ColDefsPartyLog: AgColDefsI[] = [
  Party,
  SchemeName,
  // InvoiceNumber,

];
export const AgGridDataModelColDefsPartyLog: AgGridI = {
  colDefs               : ColDefsPartyLog,
  rowSelection          : "multiple",
  columnSettings        : true,
  storageName           : StorageName.INVESTMENT_FUND_INSTALL_PARTY_ENTRY,
  initialRows           : StorageName.INVESTMENT_FUND_INSTALL_ENTRY_INITIAL_ROWS,
  filterStorageName     : StorageName.FILTER_INVESTMENT_FUND_INSTALL_PARTY_ENTRY,
  sortStorageName       : StorageName.SORT_INVESTMENT_FUND_INSTALL_PARTY_ENTRY,
  rows                  :[],
  headerHeight          : 70,
  isFilter: true,  
  isServerSidepagination : false,
  showPagination:false,
  apiUrl: API_URL_GET_ALL_INVESTMENT_FUND_INSTALL_ENTRY,
};

const SrNoColDef: AgColDefsI = {
  headerName: "Sr.No.",
  field: 'taskEventTitle',
  headerClass: "px-1 custom-column-group-cell  f-14 text-gray-color font-semibold",
  minWidth: 90,
  maxWidth: 90,
  lockPosition: left,
  sortable: true,
  editable: false,
  cellRenderer: (params) => `<span> ${params.rowIndex + 1}<span>`,
  cellClass: 'px-0 custom-column-group-cell text-center',
};
const InstallmentDatepassbook: AgColDefsI = {
  headerName: "Installment Date",
  field: 'installmentDate',
  headerClass: "px-1 custom-column-group-cell border-0 f-14 text-gray-color font-semibold ag_header_end",
  flex: 1,
  sortable: false,
  editable: false,
  resizable: true,
  minWidth: 80,
  cellClass: 'mx-0 custom-column-group-cell text-end',
  headerComponent: CustomHeaderComponent,
  cellRenderer: DateCellRendererComponent,
};

const InstallmentMonthNormal: AgColDefsI = {
  headerName: "Installment Month",
  field: 'installmentDateInFormat',
  headerClass: "px-1 custom-column-group-cell border-0 f-14 text-gray-color font-semibold ag_header_end",
  flex: 1,
  sortable: false,
  editable: false,
  resizable: true,
  minWidth: 80,
  cellClass: 'mx-0 custom-column-group-cell text-end',
  headerComponent: CustomHeaderComponent,
  cellRenderer: TextRendererComponent,
  tooltipField:'installmentDateInFormat',
};


const paymentDateColDefpassbook: AgColDefsI = {
  headerName: "Payment Date",
  field: 'paymentDate',
  headerClass: "px-1 custom-column-group-cell border-0 f-14 text-gray-color font-semibold ag_header_end",
  sortable: false,
  flex: 1,
  editable: false,
  resizable: true,
  minWidth: 80,
  cellClass: 'ms-2 custom-column-group-cell text-end',
  headerComponent: CustomHeaderComponent,
  cellRenderer: DateCellRendererComponent,
};

const AmountColdef: AgColDefsI = {
  headerName: "Amount",
  field: 'amount',
  headerClass: "px-1 custom-column-group-cell border-0 f-14 text-gray-color font-semibold ag_header_end",
  flex: 1,
  cellClass:'px-2 f-12 text-gray-color font-regular custom-column-group-cell text-end',
  sortable: true,
  editable: false,
  resizable: true,
  minWidth: 80,
  cellRenderer: NumericCellRendererComponent,
  cellRendererParams: { isAmt : true , isCursor:false},
};

const GoldRateColDef: AgColDefsI = {
  headerName: "Gold Rate/Gm",
  field: 'goldRate',
  headerClass: "px-1 custom-column-group-cell border-0 f-14 text-gray-color font-semibold ag_header_end",
  flex: 1,
  sortable: true,
  cellClass:'px-2 f-12 text-gray-color font-regular custom-column-group-cell text-end',
  editable: false,
  resizable: true,
  minWidth: 80,
  cellRenderer: NumericCellRendererComponent,
  cellRendererParams: { isAmt : true , isCursor:false},
};

const GoldwtColDef: AgColDefsI = {
  headerName: "Gold/Wt",
  field: 'goldWeight',
  headerClass: "px-1 custom-column-group-cell border-0 f-14 text-gray-color font-semibold ag_header_end",
  flex: 1,
  sortable: true,
  cellClass:'px-2 f-12 text-gray-color font-regular custom-column-group-cell text-end',
  editable: false,
  resizable: true,
  minWidth: 80,
  cellRenderer: NumericCellRendererComponent,
  cellRendererParams: { isWeight : true, isCursor:false},
};
const actionColumn: AgColDefsI =
{
  headerName: "",
  field: "",
  cellClass: "mx-0 text-end px-1",
  minWidth: 100,
  resizable: false,
  maxWidth: 100,
  extraField: "Action",
  editable: false,
  lockPosition: "right",
  lockPinned: true,
  cellRenderer: EditDeleteIconComponent,
  headerClass: params => {
    params.api.headerComponentParams = params.colDef.headerComponentParams;
    return "justify_content_start custom-column-group-cell px-0"
  },
  cellRendererParams: (params) => {
    const hasId = params?.data?.id;
    return {
      Payment: true,
      Delete: true,
      Whatsapp: true, 
      Print: true,     
      isDeleteIcon: false,
      isWhatsappPrintDisabled: hasId
    };
  },
  headerComponentParams: { moreaddButton: true, isDisable: true ,deleteThroughApi : true},
};
const actionColumnPassbook: AgColDefsI =
{
  headerName: "",
  headerClass: "justify_content_start  custom-column-group-cell  px-0",
  field: "",
  suppressNavigable: true,
  cellClass: "mx-0 text-end px-1",
  minWidth: 50,
  resizable: false,
  maxWidth: 50,
  extraField: "ActionPassbook",
  editable: false,
  lockPosition: "right",
  lockPinned: true,
  cellRenderer: EditDeleteIconComponent,
  headerComponentParams: {deleteThroughApi : true},
  cellRendererParams: { Payment:true ,Delete: true,isDeleteIcon: false, isDisable: true},
};
const EntryBY: AgColDefsI =
{
  headerName: "Entry By",
  field: "entryByName",
  headerClass: "px-0 custom-column-group-cell border-0 f-14 text-gray-color font-semibold ag_header_fontSize",
  resizable: true,
  minWidth: 80,
  sortable: true,
  editable: false,
  cellRenderer: TextRendererComponent,
  cellEditor: AgGridCustomDropdownComponent,
  cellEditorParams: {
    values: () => {
      const storageService = new StorageService();
      const storage = StorageName;
      return storageService.retrieve(storage.USER_DROPDOWN)
    },
  },
}

export const ColDefsAddLogPassbookTab: AgColDefsI[] = [
  SrNoColDef,
  InstallmentDatepassbook,
  paymentDateColDefpassbook,
  AmountColdef,
  GoldRateColDef,
  GoldwtColDef,
  EntryBY,
  actionColumnPassbook,
];
export const ColDefsAddLogNormalTab: AgColDefsI[] = [
  SrNoColDef,
  // InstallmentDatepassbook,
  InstallmentMonthNormal,
  paymentDateColDefpassbook,
  AmountColdef,
  GoldRateColDef,
  GoldwtColDef,
  EntryBY,
  actionColumn,
];


export const AgGridDataModelPassbookTab: AgGridI = {
  colDefs: ColDefsAddLogPassbookTab,
  rowSelection: "multiple",
  rowHeight:28,

};

export const AgGridDataModelNormalTab: AgGridI = {
  colDefs: ColDefsAddLogNormalTab,
  rowSelection: "multiple",
  storageName: StorageName.INVESTMENT_FUND_INSTALLMENT_ENTRY_GRID,
  rows: [],
  headerHeight: 40,
  rowHeight: 28,
  isFilter: true,
  showPagination: false
};

export class InstallmentEntryModel {
  voucherTypeId: number = 0;
  voucherNo: number = 0;
  schemeId: number
  accountLedgerId: number
  joiningDate: any
  maturityDate: string
  salePersonId: string
}

export class GetResponsEntryModel {
  id: number
  schemeName: string
  duration: number
  durationInFormat: any
  durationTypeId: number
  durationTypeName: string
  redemptionOnId: number
  redemptionOnName: string
  installmentTypeId: number
  installmentTypeName: string
  installmentAmount: number
  active: any
}


export class InsertNormaltabData {
  data: any[];
}
export enum InstallmentEntries {
  Normal = 1,
  Passbook = 2,
}